import { Circle, G, Path, Rect, Svg } from "react-native-svg";

import { useTheme } from "~/styles/theme";

/**
 * The Florafolio logomark. Generated from the same geometry as the app
 * icon and the website favicon, so the three surfaces cannot drift apart.
 * Colours are the brand's own — a mark should not follow semantic tokens.
 */
const schemes = {
  light: { plate: "#fcf3e3", ink: "#013d5a", accent: "#708c69" },
  dark: { plate: "#0d1f14", ink: "#e6f0ea", accent: "#8fae86" },
} as const;

export function Logomark({ size = 26 }: { size?: number }) {
  const { scheme } = useTheme();
  const c = schemes[scheme === "dark" ? "dark" : "light"];
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      accessibilityLabel="Florafolio"
    >
      <Path
        d="M14 11 H39 L52 24 V51 A3 3 0 0 1 49 54 H17 A3 3 0 0 1 14 51 Z"
        fill="none"
        stroke={c.ink}
        strokeWidth="3.2"
        strokeLinejoin="round"
      />
      <Path
        d="M39 11 V24 H52"
        fill="none"
        stroke={c.ink}
        strokeWidth="3.2"
        strokeLinejoin="round"
      />
      <Path
        d="M44 29 C44 43, 34 50, 23 48 C23 34, 33 27, 44 29 Z"
        fill={c.accent}
      />
      <Path
        d="M26 45.5 C31 39.5, 37 34, 42.5 31"
        fill="none"
        stroke={c.plate}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </Svg>
  );
}
